import img1 from "../../assets/1.jpg"
import img2 from "../../assets/2.jpg"
import img3 from "../../assets/3.jpg"
import img4 from "../../assets/4.jpg"
import img5 from "../../assets/5.jpg"
import img6 from "../../assets/6.jpg"
import img8 from "../../assets/8.jpg"
import img7 from "../../assets/7.jpg"


const PriceData =[
    {   
        id:1,
        img:img1,
        name:"hornosa",
        sub:"accessories",
        price:"58"
    },
    {   
        id:2,
        img:img2,
        name:"hoya carnosa",
        sub:"accessories",
        price:"58"
    },
    {   
        id:3,
        img:img3,
        name:"hoya carnosa",
        sub:"flower pot",
        price:"58"
    },
    {   
        id:4,
        img:img8,
        name:"hoya carnosa",
        sub:"flower with flower pot",
        price:"58"
    },
    {   
        id:5,
        img:img4,
        name:"hoya huju",
        sub:"accessories",
        price:"58"
    },
    {   
        id:6,
        img:img5,
        name:"hoya carnosa",
        sub:"accessories",
        price:"58"
    },
    {   
        id:7,
        img:img6,
        name:"hoya ca",
        sub:"accessories",
        price:"58"
    },
    {   
        id:8,
        img:img7,
        name:"ukul popinf",
        sub:"accessories",
        price:"58"
    },
]
export default PriceData;